<template>
  <div class="side-menu flex-column ">
    <div class="navbar-brand-box">
      <div class="company-box d-flex" :class="globalData.channel_selected === '' && (this.$route.path == '/conversations' || this.$route.path == globalData.cCode + '/conversations')  ? 'channel-selected' : ''">
        <img class="pointer" src="/icons/salework.svg" @click="setChannel('')" v-b-tooltip.right="'Tất cả các kênh'">
      </div>

      <div v-if="globalData.initData?.pages.find(p=>p._id?.channel ===  'Facebook')" class="company-box d-flex" :class=" this.$route.path === '/conversations' && globalData.channel_selected === 'Facebook' ? 'channel-selected' : ''">
        <img class="pointer" src="/icons/logo/Facebook-cicle.svg" @click="setChannel('Facebook')" v-b-tooltip.right="'Facebook'">
        <div class="unread" v-if="globalData.channel.FACEBOOK.unread"></div>
      </div>

      <div v-if="globalData.initData?.pages.find(p=>p._id?.channel ===  'Instagram')" class="company-box d-flex" :class=" this.$route.path === '/conversations' && globalData.channel_selected === 'Instagram' ? 'channel-selected' : ''">
        <img class="pointer" src="/icons/instagram.svg" @click="setChannel('Instagram')" v-b-tooltip.right="'Instagram'">
        <div class="unread" v-if="globalData.channel.INSTAGRAM.unread"></div>
      </div>

      <div v-if="globalData.initData?.pages.find(p=>p._id?.channel ===  'ZaloOA')"  class="company-box d-flex" :class="this.$route.path === '/conversations' && globalData.channel_selected === 'ZaloOA'  ? 'channel-selected' : ''">
        <img class="pointer" src="/icons/logo/ZaloOA-cicle.svg" @click="setChannel('ZaloOA')" v-b-tooltip.right="'ZaloOA'">
        <div class="unread" v-if="globalData.channel.ZALO_OA.unread"></div>
      </div>

      <div v-if="globalData.initData?.pages.find(p=>p._id?.channel ===  'Lazada')"  class="company-box d-flex" :class=" this.$route.path === '/conversations' && globalData.channel_selected === 'Lazada' ? 'channel-selected' : ''">
        <img class="pointer" src="/icons/lazada.svg" @click="setChannel('Lazada')" v-b-tooltip.right="'Lazada'">
        <div class="unread" v-if="globalData.channel.LAZADA.unread"></div>
      </div>

      <div v-if="globalData.initData?.pages.find(p=>p._id?.channel ===  'TikTok')"  class="company-box d-flex" :class=" this.$route.path === '/conversations' && globalData.channel_selected === 'TikTok' ? 'channel-selected' : ''">
        <img class="pointer" src="/icons/logo/Tiktok-circle.svg" @click="setChannel('TikTok')" v-b-tooltip.right="'TikTok'">
        <div class="unread" v-if="globalData.channel.TIKTOK.unread"></div>
      </div>

      <div v-if="globalData.initData?.pages.find(p=>p._id?.channel ===  'Shopee')"  class="company-box d-flex" :class=" this.$route.path === '/conversations' && globalData.channel_selected === 'Shopee' ? 'channel-selected' : ''">
        <img class="pointer" src="/icons/logo/Shopee-circle.svg" @click="setChannel('Shopee')" v-b-tooltip.right="'Shopee'">
        <div class="unread" v-if="globalData.channel.SHOPEE.unread"></div>
      </div>

      <div v-if="globalData.initData?.pages.find(p=>p._id?.channel === 'LiveChat')"  class="company-box d-flex" :class=" this.$route.path === '/conversations' && globalData.channel_selected === 'LiveChat' ? 'channel-selected' : ''">
        <img class="pointer" src="/icons/logo/LiveChat.svg" width="36px" height="36px" @click="setChannel('LiveChat')" v-b-tooltip.right="'LiveChat'">
        <div class="unread" v-if="globalData.channel.LIVECHAT.unread"></div>
      </div>

      <div class="company-box d-flex"
           :class="this.$route.path === '/connection' || this.$route.path === globalData.cCode + '/connection' ? 'active': ''">
        <a class="" id="pills-user-tab-2" data-bs-toggle="pill" role="tab">
          <router-link :to=" globalData.cCode + '/connection'">
            <div class="connection-icon justify-content-center" v-b-tooltip.hover.right="'Liên kết tài khoản'">
              <b-icon scale="2" class=" icon-center pointer" icon="link-45deg" aria-hidden="true"></b-icon>
            </div>
          </router-link>
        </a>
      </div>
    </div>
    <div class="flex-lg-column mt-auto">
      <ul class="nav nav-pills side-menu-nav justify-content-center" role="tablist">
        <li v-if="globalData.isAdmin"
            id="v-step-0"
            class="nav-item"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Profile"
        >
          <a
              class="nav-link rounded-circle mx-1"
              id="pills-user-tab-0"
              data-bs-toggle="pill"
              role="tab"
          >
            <router-link :to=" globalData.cCode + '/dashboard'"
                         class="nav-link  d-flex align-items-center justify-content-center" active-class="active"
                         v-b-tooltip.hover.right="'Báo cáo thống kê'" >
              <div :class="this.$route.path == '/dashboard' || this.$route.path == globalData.cCode + '/dashboard' ? 'color-blue': ''">
                <span class="icon2-nav-statistic"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
              </div>
            </router-link>
          </a>
        </li>
        <li
            id="v-step-order"
            class="nav-item"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Profile"
        >
          <a
              class="nav-link rounded-circle mx-1"
              id="pills-user-tab-order"
              data-bs-toggle="pill"
              role="tab"
          >
            <router-link :to=" globalData.cCode + '/orders'"
                         class="nav-link  d-flex align-items-center justify-content-center" active-class="active"
                         v-b-tooltip.hover.right="'Đơn hàng'" >
              <div :class="this.$route.path == '/orders' || this.$route.path == globalData.cCode + '/orders' ? 'color-blue': ''">
                <span class="icon2-nav-product"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
              </div>
            </router-link>
          </a>
        </li>
        <li
            id="v-step-rating"
            class="nav-item"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Profile"
        >
          <a
              class="nav-link rounded-circle mx-1"
              id="pills-user-tab-rating"
              data-bs-toggle="pill"
              role="tab"
          >
            <router-link :to=" globalData.cCode + '/review'"
                         class="nav-link  d-flex align-items-center justify-content-center" active-class="active"
                         v-b-tooltip.hover.right="'Đánh giá'" >
              <div :class="this.$route.path == '/review' || this.$route.path == globalData.cCode + '/review' ? 'color-blue': ''">
                <span class="icon2-nav-review1"><span class="path1"></span><span class="path2"></span></span>
              </div>
            </router-link>
          </a>
        </li>
        <li v-if="checkPermission()"
            id="v-step-1"
            class="nav-item"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Profile"
        >
          <a
              class="nav-link rounded-circle mx-1"
              id="pills-user-tab-1"
              data-bs-toggle="pill"
              role="tab"
          >
            <router-link :to=" globalData.cCode + '/automation'"
                         class="nav-link  d-flex align-items-center justify-content-center" active-class="active"
                         v-b-tooltip.hover.right="'Tự động hoá'" >
              <div :class="this.$route.path == '/automation' || this.$route.path == globalData.cCode + '/automation' ? 'color-blue': ''">
                <span class="icon2-nav-auto-setting"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
              </div>
            </router-link>
          </a>
        </li>

        <li v-if="checkPermission()" id="v-step-4" class="nav-item" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-original-title="Profile">
          <a class="nav-link rounded-circle mx-1" id="pills-user-tab-4" data-bs-toggle="pill" role="tab">
            <router-link :to=" globalData.cCode + '/setting'"
                         class="nav-link  d-flex align-items-center justify-content-center"
                         active-class="active"
                         v-b-tooltip.hover.right="'Thiết lập'">
              <div  :class="this.$route.path == '/setting' || this.$route.path == globalData.cCode + '/setting' ? 'color-blue': ''">
                <span class="icon2-nav-setting"><span class="path1"></span><span class="path2"></span></span>
              </div>
            </router-link>
          </a>
        </li>

        <li id="v-step-6" class="nav-item" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-original-title="Profile">
          <a class="nav-link rounded-circle" id="pills-user-tab-6" data-bs-toggle="pill" role="tab">
            <div v-b-tooltip.hover.right="'Hướng dẫn sử dụng'" @click="openGuide()">
              <span class="icon2-nav-ask"><span class="path1"></span><span class="path2"></span></span>
            </div>
          </a>
        </li>
      </ul>
    </div>

  </div>


</template>

<script>
// import DownloadAppModal from "@/components/modals/DownloadAppModal";

export default {
  name: "SideMenu",
  methods: {

    openGuide(){
      const url = 'https://docs.salework.net/salework-tai-lieu/v/salework-all-chat';
      window.open(url, '_blank');
    },
    checkPermission() {
      return this.globalData.isAdmin
    },

    setChannel(channel){
      // this.globalData.channel_selected = '';
      // if ( this.$route.path === '/conversations' && this.globalData.channel_selected === channel) return
      // if (this.$route.path !== '/conversations') {
      //   const router =  this.globalData.cCode +'/conversations';
      if(this.$route.query.channel && this.$route.query.conversation_id && this.$route.query.customer_id){
        this.$router.push(this.globalData.cCode +'/conversations');
        this.globalData.channel_selected = channel;
        this.globalData.conversation_selected = {};
        this.$root.$emit('getConversation')
        return
      }else if(this.$route.path === '/conversations' && this.globalData.channel_selected === channel){
        return;
      }
      if(this.$route.path !== '/conversations'){
        this.$router.push(this.globalData.cCode +'/conversations');
      }
      this.globalData.channel_selected = channel;
      this.globalData.conversation_selected = {};
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-menu {
  background-color: #344fa1;
  height: calc(100vh - 50px);
  border-right: 1px solid #ebebeb;
  display: flex;
  flex-direction: column;
  align-items: center;

  .item {
    font-size: 28px;
    display: block;
    padding: 14px;
    color: #ffffff;
    text-align: center;
  }

  .item:hover {
    background-color: #3d84b8;
  }
}

.group-title {
  display: none;
}

.company-box {
  justify-content: center;
  align-items: center;
  margin-top: 2px;
  margin-bottom: 2px;
  padding: 8px 0px;
  position: relative;

  .unread{
    width: 14px;
    height: 14px;
    background-color: #ff2a2a;
    border-radius: 50%;
    border: 2px solid white;
    position: absolute;
    top: 6px;
    right: 6px;
  }
}

#fanpage .el-badge__content.is-fixed {
  top: 16px !important;
}

.side-menu-nav .nav-item .nav-link {
  width: 32px;
  height: 32px;
  line-height: 32px;
  font-size: 18px;
  text-align: center;
  margin: 0 auto;
  padding: 0;
  border-radius: 50%;

  &.active {
    background-color: #E1EDFD !important;
    color: #0A58C0 !important;
    a {
      background-color: #E1EDFD !important;
      color: #0A58C0 !important;
    }
  }
}

.support-live-dot {
  width: 9px;
  height: 9px;
  background-color: #CF4547;
  display: inline-block;
  margin-bottom: 10px;
  margin-left: -6px;
  border: 1px solid white;
  border-radius: 50%;
}

.side-menu {
  position:relative;
  min-width: 52px;
  max-width: 52px;
  height: calc(100vh - 48px);
  min-height: 570px;
  background-color: white;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  z-index: 9;
  border-right: 1px solid #DCDFE9;
}

.side-menu a {
  color: #696B72;

}

.side-menu .navbar-brand-box {
  text-align: center;
}

.side-menu .navbar-brand-box .logo {
  line-height: 70px;
}
.side-menu .navbar-brand-box .logo-dark {
  display: block;
}
.side-menu .navbar-brand-box .logo-light {
  display: none;
}
.side-menu .theme-mode-icon:before {
  content: "";
}
.side-menu-nav .nav-item {
  margin: 2px 0;
}


.side-menu-nav .profile-user {
  height: 36px;
  width: 36px;
  background-color: #f0eff5;
  padding: 3px;
}

.nav-icon{
  margin-left: 16px;
}

.active {
  background-color: #E1EDFD !important;
  color: #0A58C0 !important;
}

.channel-selected {
  background: #D4E4FF;
}
.connection-icon{
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: rgba(236, 236, 236, 1);
}

.icon-center{
  margin-top: 9px;
  color: #1B75FB;
}

.color-blue:before{
  color: #2970dd!important;
}


</style>
